import React from 'react';
import cx from 'classnames';
import styles from '../style.module.scss';

import { palletsByCountry } from 'utils/journey';

const t = {
  american: 'Us',
  european: 'Eu',
};

const MaxPallets = ({ rowData, cellData }) => {
  const pallet_type =
    (rowData && rowData.carrier && palletsByCountry[rowData.carrier.country]) ||
    palletsByCountry.default;
  const content = cellData ? `${cellData} ${t[pallet_type]}` : null;

  return <div className={cx(styles.bold, styles.rightCell)}>{content}</div>;
};

export default MaxPallets;
